"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _TicketType = _interopRequireDefault(require("../TicketType"));
var _excluded = ["mailGroups", "value", "currentManager"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CLASS_NAME_PREFIX = _Selector["default"].CLASS_NAME_PREFIX;
var ticketTypePropTypes = _TicketType["default"].propTypes;
var PLACEHOLDER = 'Выберите группу';
var StyledFilter = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "TicketFilterByMailGroup__StyledFilter",
  componentId: "sc-1028qco-0"
})(["border:1px solid #e6e9ee;box-sizing:border-box;border-radius:4px;padding:0 3px;.", "__multi-value{background:#f5f3f2;border:none;}.", "__multi-value__label{padding:0 0 0 10px;}", "__placeholder{color:#4d4d4d;}"], CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX);
var TicketFilterByMailGroup = /*#__PURE__*/function (_React$PureComponent) {
  function TicketFilterByMailGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilterByMailGroup);
    _this = _callSuper(this, TicketFilterByMailGroup, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilterByMailGroup, _React$PureComponent);
  return (0, _createClass2["default"])(TicketFilterByMailGroup, [{
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var formatedValue = Array.isArray(value) ? value.map(function (v) {
        return v.value;
      }) : null;
      this.el.name = name;
      this.el.value = formatedValue;
      var event = new CustomEvent('change', {
        bubbles: true
      });
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.el = _reactDom["default"].findDOMNode(ref);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        mailGroups = _this$props2.mailGroups,
        value = _this$props2.value,
        currentManager = _this$props2.currentManager,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      if ((0, _isEmpty2["default"])(mailGroups)) {
        return null;
      }
      var formatedValue = null;
      if (Array.isArray(value)) {
        formatedValue = value.map(function (v) {
          return (0, _find2["default"])(mailGroups, {
            value: v
          });
        });
      }

      // сортируем группы по скилл-группам менеджера
      var sortedMailGroups = mailGroups.sort(function (a, b) {
        var indexA = currentManager.skillGroupIds.indexOf(a.skillGroupId);
        var indexB = currentManager.skillGroupIds.indexOf(b.skillGroupId);
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        return 0;
      }).map(function (mailGroup) {
        return {
          label: mailGroup.label,
          value: mailGroup.value,
          isHighlighted: currentManager.skillGroupIds.includes(mailGroup.skillGroupId)
        };
      });
      return /*#__PURE__*/_react["default"].createElement(StyledFilter, (0, _extends2["default"])({}, props, {
        isMulti: true,
        isSearchable: true,
        onChange: this.handleChange,
        options: sortedMailGroups,
        placeholder: PLACEHOLDER,
        ref: this.handleRef,
        value: formatedValue,
        closeMenuOnSelect: false,
        blurInputOnSelect: false
      }));
    }
  }]);
}(_react["default"].PureComponent);
TicketFilterByMailGroup.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  mailGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, ticketTypePropTypes), {}, {
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })).isRequired),
  value: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired)
};
TicketFilterByMailGroup.defaultProps = {
  className: '',
  name: '',
  onChange: Function.prototype,
  mailGroups: null,
  value: null
};
var _default = exports["default"] = TicketFilterByMailGroup;